/**
 * When the BOGOS "add gift" button is clicked, I trigger the theme and Rebuy
 * refresh events so the cart updates without a page reload.
 */
const BOGOS_BUTTON = '.bogos-gift-item-add-btn';
const REFRESH_DELAY_MS = 800;

function dispatch(eventName) {
  document.dispatchEvent(new CustomEvent(eventName));
}

function refreshCart() {
  dispatch('cart:refresh');
  dispatch('rebuy:cart.change');
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element) || !target.closest(BOGOS_BUTTON)) return;
  setTimeout(refreshCart, REFRESH_DELAY_MS);
});
